<template>
  <div>
      <h1>Mass campaigns</h1>
      <steppers></steppers>
  </div>
</template>

<script>
// todo change name
import Steppers from '@/components/pages/multipleCampaignsCreation/Steppers'

export default {
  name: "MassCampaigsPage",
  components: {
    Steppers,
  }
}
</script>

<style scoped>

</style>
